import * as React from 'react';

import { cn } from '@/lib/utils';

function Textarea({ className, maxLength, ...props }: React.ComponentProps<'textarea'>) {
  const [charCount, setCharCount] = React.useState(0);
  const displayCharCount =
    typeof props.value === 'string' || typeof props.value === 'number'
      ? String(props.value).length
      : charCount;

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCharCount(e.target.value.length);
    props.onChange?.(e);
  };

  if (maxLength) {
    return (
      <div className="relative w-full">
        <textarea
          data-slot="textarea"
          className={cn(
            'border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
            'pb-8',
            className
          )}
          maxLength={maxLength}
          {...props}
          onChange={handleChange}
        />
        <div className="absolute right-3 bottom-2 text-xs text-muted-foreground pointer-events-none">
          {displayCharCount}/{maxLength}
        </div>
      </div>
    );
  }

  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        className
      )}
      {...props}
    />
  );
}

export { Textarea };
